// JOBE-0158.3: KpiTile — a clickable (or static) KPI display tile.
// The tone dot on the label reflects status; the value itself always
// stays ink-colored (design-system.md §"KPI tile").

import './KpiTile.css';

const TONE_CLASS = {
  ok: 'kpi-tone-ok',
  warn: 'kpi-tone-warn',
  bad: 'kpi-tone-bad',
};

/**
 * @param {object} props
 * @param {string} props.label
 * @param {string|number} props.value
 * @param {string} [props.unit]
 * @param {'ok'|'warn'|'bad'} [props.tone]
 * @param {React.ReactNode} [props.spark]
 * @param {Function} [props.onClick]
 * @param {Array<{label: string, value: string|number}>} [props.subRows]
 */
export function KpiTile({ label, value, unit, tone, spark, onClick, subRows }) {
  const Tag = onClick ? 'button' : 'div';
  const isNumeric = typeof value === 'number' || (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value));

  return (
    <Tag
      className={['kpi-tile', onClick ? 'kpi-tile--interactive' : ''].filter(Boolean).join(' ')}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
    >
      <div className="kpi-label-row">
        {tone && <span className={['kpi-dot', TONE_CLASS[tone]].filter(Boolean).join(' ')} aria-hidden="true" />}
        <span className="kpi-label">{label}</span>
      </div>

      <div className="kpi-value-row">
        <span className={['kpi-value', isNumeric ? 'kpi-value--numeric' : 'kpi-value--string'].join(' ')}>
          {value}
        </span>
        {unit && <span className="kpi-unit">{unit}</span>}
      </div>

      {subRows && subRows.length > 0 && (
        <div className="kpi-subrows">
          {subRows.map((row, i) => (
            <div key={i} className="kpi-subrow">
              <span className="kpi-subval">{row.value}</span>
              <span className="kpi-sublbl">{row.label}</span>
            </div>
          ))}
        </div>
      )}

      {spark && (
        <div className="kpi-spark-footer">
          {spark}
        </div>
      )}
    </Tag>
  );
}
